import { render, staticRenderFns } from "./FeedbackStatus.vue?vue&type=template&id=1811dc2d"
import script from "./FeedbackStatus.vue?vue&type=script&lang=js"
export * from "./FeedbackStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports